import { EmbedConfig } from '../../..';
import React, { createContext, useContext } from 'react';

export interface EmbedDynamicConstants {
  isMobile: boolean;
  stickyDiv: React.RefObject<HTMLDivElement>;
}

interface AppContextProps {
  config: EmbedConfig;
  dynamicConstants: EmbedDynamicConstants;
}

const AppContext = createContext<AppContextProps | undefined>(undefined);

interface WithAppPropsBase {
  config: EmbedConfig;
  dynamicConstants: EmbedDynamicConstants;
}

type WithAppProps = React.PropsWithChildren<WithAppPropsBase>;

export function WithApp(props: WithAppProps) {
  return (
    <AppContext.Provider value={{ config: props.config, dynamicConstants: props.dynamicConstants }}>
      {props.children}
    </AppContext.Provider>
  );
}

export function useApp() {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error('useApp must be used within a AppProvider');
  }
  return context;
}
